import type { ReactNode } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { ChevronLeft, LogOut } from 'lucide-react'
import { useAuth } from '../auth/AuthProvider'
import { FLAVOR } from '../flavor/flavor'
import { BrandMark } from '@foroba/ui'
import styles from './Topbar.module.css'

const SECTION_TITLES: [string, string][] = [
  ['/accounts',     'Naforo'],
  ['/transactions', 'Naforo'],
  ['/recurring',    'Naforo'],
  ['/spending',     'Naforo'],
  ['/forecasts',    'Naforo'],
  ['/budgets',      'Naforo'],
  ['/goals',        'Naforo'],
  ['/debts',        'Naforo'],
  ['/import',       'Naforo'],
  ['/portfolio',    'Yiriba'],
  ['/etf',          'Yiriba'],
  ['/crypto',       'Yiriba'],
  ['/asset/',       'Yiriba'],
  ['/analysis',     'Yiriba'],
  ['/backtest',     'Yiriba'],
  ['/screener',     'Yiriba'],
  ['/foroba',       'Kelen'],
]

// Paths where no back button is needed (root/tab destinations)
const ROOT_PATHS = new Set([
  '/', '/accounts', '/transactions', '/recurring', '/spending',
  '/forecasts', '/budgets', '/goals', '/debts',
  '/portfolio', '/etf', '/crypto', '/analysis', '/backtest',
  '/screener', '/compare', '/sentiment', '/markets',
  '/import', '/tax', '/simulate',
  '/foroba', '/foroba/profile', '/foroba/settings', '/foroba/security', '/foroba/household',
  '/legal', '/pazuru/lab', '/pazuru/import-log', '/tsumi/lab',
])

function resolveTitle(pathname: string): string {
  for (const [prefix, title] of SECTION_TITLES) {
    if (pathname.startsWith(prefix)) return title
  }
  return FLAVOR.appName
}

interface TopbarProps {
  right?: ReactNode
}

export function Topbar({ right }: TopbarProps) {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { logout } = useAuth()
  const title = resolveTitle(pathname)
  const showBack = !ROOT_PATHS.has(pathname)

  return (
    <header className={styles.topbar}>
      <div className={styles.left}>
        {showBack && (
          <button
            className={styles.iconBtn}
            onClick={() => void navigate(-1)}
            aria-label="Go back"
            type="button"
          >
            <ChevronLeft size={22} strokeWidth={2} />
          </button>
        )}
      </div>
      <span className={styles.wordmark}>
        <BrandMark brand={FLAVOR.dataApp} size={20} className={styles.wordmarkMark} />
        <span className={styles.wordmarkApp}>{title}</span>
      </span>
      <div className={styles.right}>
        {right ?? (
          <button
            className={styles.iconBtn}
            onClick={logout}
            aria-label="Sign out"
            type="button"
          >
            <LogOut size={18} strokeWidth={1.75} />
          </button>
        )}
      </div>
    </header>
  )
}
